import { Box, Button, Flex, IconBox, Stack, Text } from "@compono/ui";
import {
  AiSolidIcon,
  ArrowRightOutlineIcon,
  CloseSolidIcon,
} from "@compono/ui-icons";
import { useEffect, useState } from "react";
import { useOrganisation, useUser } from "~/auth-layer";
import { User } from "~/components/auth";
import { mixpanel } from "@shortlyster/analytics-kit";

const heyComponoColor = "rgb(34 211 238 / var(--tw-text-opacity, 1))";
const heyComponoButtonHoverColor = "rgb(8 145 178 / var(--tw-text-opacity, 1))";
const heyComponoStyle = {
  position: "relative",
  backgroundColor: "#343265",
  borderRadius: "18px",
  border: `2px solid #22d3ee66`,
  padding: "20px",
  marginTop: "22px",
};

const heyComponoButtonStyle = {
  color: "black.100",
  backgroundColor: heyComponoColor,
  "&:hover": {
    backgroundColor: heyComponoButtonHoverColor,
  },
  transitionDuration: "0.3s",
};

export const HeyComponoNavPanel = () => {
  const [organisation] = useOrganisation();
  const [user] = useUser<User>();
  const [isVisible, setIsVisible] = useState(true);

  useEffect(() => {
    const heyComponoPanelLocalStorage = localStorage.getItem("heyComponoPanel");
    if (heyComponoPanelLocalStorage === "dismissed") {
      setIsVisible(false);
    }
  }, []);

  const onHeyComponoClick = () => {
    mixpanel.track("Hey Compono - Link Followed", {
      userId: user?.id,
      organisationId: organisation?.id,
      organisationName: organisation?.name,
    });
    window.open("https://www.heycompono.com/", "_blank", "noopener,noreferrer");
  };

  const onCloseClick = () => {
    localStorage.setItem("heyComponoPanel", "dismissed");
    setIsVisible(false);
    mixpanel.track("Hey Compono - Link Dismissed", {
      userId: user?.id,
      organisationId: organisation?.id,
      organisationName: organisation?.name,
    });
  };

  if (!isVisible) {
    return null;
  }

  return (
    <Stack gap={4} sx={heyComponoStyle}>
      <Box
        data-testid="hey-compono-close-button"
        onClick={onCloseClick}
        sx={{
          position: "absolute",
          top: "15px",
          right: "20px",
          cursor: "pointer",
        }}
      >
        <IconBox
          icon={CloseSolidIcon}
          sx={{
            fontSize: "14px",
            color: "white",
            transition: "all 0.3s ease",
            "&:hover": {
              color: heyComponoColor,
              transform: "scale(1.2)",
            },
          }}
        />
      </Box>
      <Flex sx={{ gap: "10px", alignItems: "center" }}>
        <IconBox icon={AiSolidIcon} sx={{ fontSize: "20px" }}></IconBox>
        <Text size="xs" sx={{ color: heyComponoColor }}>
          <strong>INTRODUCING HEY COMPONO</strong>
        </Text>
      </Flex>
      <Text
        size="md"
        sx={{ color: "white", display: "inline", fontWeight: "bold" }}
      >
        An AI{" "}
        <Text size="md" sx={{ color: heyComponoColor, display: "inline" }}>
          <strong>coach</strong>
        </Text>{" "}
        that truly gets you.
      </Text>
      <Text size="xs" sx={{ color: "white" }}>
        Navigate workplace challenges, grow your skills, and thrive in your role
        with personalised AI coaching.
      </Text>
      <Button
        iconRight={ArrowRightOutlineIcon}
        sx={heyComponoButtonStyle}
        onClick={onHeyComponoClick}
      >
        Get started free
      </Button>
    </Stack>
  );
};
